import { SMS } from 'constants/messageMediums';
import BaseSendEditor, { BaseSendEditorProps } from '../BaseSendEditor';

export const SendSMSEditor = (props: BaseSendEditorProps) => {
  return (
    <BaseSendEditor
      shouldShowDeliverySectionHeader
      shouldShowQuietHours
      shouldShowRateLimit
      {...props}
      messageMedium={SMS}
    />
  );
};
